import styles from "./PartnershipCardPointsSideDrawer.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { OpenInNewOutlined as OpenInNew24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";

type PartnershipCardPointsSideDrawerProps = {
  handleClose: () => void;
  drawerIsOpen: boolean;
  points: number;
};

export const PartnershipCardPointsSideDrawer = ({
  handleClose,
  drawerIsOpen,
  points,
}: PartnershipCardPointsSideDrawerProps) => {
  const financeLink =
    "http://www.johnlewisfinance.com/credit-cards/partnership-card.html?sourcecode=3521500AAJLPDOM16500&utm_source=www.johnlewis.com&utm_medium=Banner&utm_campaign=PC0243&track=jli:JLPC0243";
  return (
    <Drawer
      isOpen={drawerIsOpen}
      onClose={handleClose}
      heading="Partnership Credit Card"
      className={styles.drawerContent}
    >
      <div className={styles.drawerContent__highlightWrapper}>
        <h3>
          Earn <strong>{points} points</strong> when you pay for this product
          with your <strong>Partnership Credit Card.</strong>
        </h3>
        <h3>
          <strong>{`28.9% APR Representative`}</strong> (variable).
        </h3>
        <div
          className={
            styles.drawerContent__highlightWrapper__findOutMoreContainer
          }
        >
          <UnderlinedButton
            className={styles.drawerContent__highlightWrapper__findOutMore}
            tag="a"
            target="_blank"
            data-testid="cardpoints:link:findoutmore"
            size="large"
            href={financeLink}
          >
            Find out more
          </UnderlinedButton>
          <OpenInNew24PxOutlinedIcon size="medium" />
        </div>
      </div>
      <div className={styles.drawerContent__infoWrapper}>
        <h3>
          <strong>{`Your Partnership Credit Card Benefits`}</strong>
        </h3>
        <h4>{`Earn points`}</h4>
        <p>
          {`For every 500 points, we'll send you a £5 voucher to treat yourself at John Lewis or Waitrose.*`}
        </p>
        <h4>{`No annual fee and widely accepted`}</h4>
        <div className={styles.drawerContent__infoWrapper__borderWrapper}>
          <p>{`Check your eligibility without impacting your credit score.`}</p>
        </div>{" "}
        <h3>
          <strong>{`John Lewis plc is a credit broker, not a lender, introducing the Partnership Credit Card under exclusive arrangements with the lender NewDay Ltd.`}</strong>
        </h3>
        <div className={styles.drawerContent__infoWrapper__smallPrintWrapper}>
          <p>
            {`John Lewis Money and John Lewis Finance are trading names of John Lewis plc. Registered office: 1 Drummond Gate, Pimlico, London SW1V 2QQ. Registered in England and Wales (company number: 233462). Authorised and regulated by the Financial Conduct Authority (firm reference number: 724309).`}
          </p>
          <p>{`Credit is provided by NewDay Ltd. Registered in England and Wales (company number: 7297722). Registered office: 7 Handyside Street, London, N1C 4DA. NewDay Ltd is authorised and regulated by the Financial Conduct Authority (firm reference number: 690292) and is also authorised by the Financial Conduct Authority under the Payment Services Regulations 2017 (firm reference number: 555318) for the provision of payment services.`}</p>
          <p>{`This card is issued by NewDay Ltd pursuant to license by Mastercard International Incorporated.`}</p>
          <p>
            {`Credit subject to status. 18 years +. UK residents. T&Cs apply. `}
            <b>John Lewis plc is a credit broker. NewDay Ltd is the lender.</b>
          </p>
          <p>
            {`* Rewards subject to terms and conditions - see `}{" "}
            <a
              href="https://www.johnlewisfinance.com/credit-cards/partnership-card/terms-and-conditions.html"
              target="_blank"
              rel="noreferrer"
            >{`johnlewiscreditcard.com/terms`}</a>
          </p>
        </div>
      </div>
    </Drawer>
  );
};
